export default __webpack_public_path__ + "static/media/d_roworkPM.1952c718.avif";